import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProviderCertificationDetails,
  fetchProviderCertificationSuggesion,
  deleteProviderGeneralCert,
  saveProviderCertifications,
} from "./GeneralCertificationActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerCertificationSuggesions = createSlice({
  name: "providerCertificationSuggesions",
  initialState: {
    isCertsugLoading: false,
    certSuggestion: [],
    certSugError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderCertificationSuggesion.pending, (state) => {
        state.isCertsugLoading = true;
        state.certSugError = null;
      })
      .addCase(
        fetchProviderCertificationSuggesion.fulfilled,
        (state, action) => {
          state.isCertsugLoading = false;
          state.certSuggestion = action.payload?.data?.data?.certificationSearchPagingResponseDTO || [];
        }
      )
      .addCase(
        fetchProviderCertificationSuggesion.rejected,
        (state, action) => {
          state.isCertsugLoading = false;
          state.certSugError = action.error.message;
        }
      );
  },
});

const providerCertificationDetails = createSlice({
  name: "providerCertificationDetails",
  initialState: {
    isCertDataLoading: false,
    certData: [],
    certError: null,
    certErrorMsg: "",
  },
  reducers: {
    addUpdateProviderCertification: (state, action) => {
      state.certData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderCertificationDetails.pending, (state) => {
        state.isCertDataLoading = true;
        state.certError = null;
      })
      .addCase(fetchProviderCertificationDetails.fulfilled, (state, action) => {
        state.isCertDataLoading = false;
        if (
          action.payload.metadata &&
          action.payload.metadata.outcome.status === 200
        ) {
          state.certData =
            action.payload.data.providerGeneralCertificationResponseDTO || [];
          state.certError = false;
        } else {
          state.certError = true;
          state.certErrorMsg = action.payload.metadata
            ? getApiErrorMessage(action.payload.metadata.outcome.status)
            : "Failed to load certification data";
        }
      })
      .addCase(fetchProviderCertificationDetails.rejected, (state, action) => {
        state.isCertDataLoading = false;
        state.certError = action.error.message;
      });
  },
});

const deleteProviderCertification = createSlice({
  name: "deleteProviderCertification",
  initialState: {
    isDeleteLoading: false,
    deleteSuccess: false,
    deleteError: null,
    deleteErrorMsg: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteProviderGeneralCert.pending, (state) => {
        state.isDeleteLoading = true;
        state.deleteError = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteProviderGeneralCert.fulfilled, (state, action) => {
        state.isDeleteLoading = false;
        if (!action.payload.success) {
          state.deleteError = true;
          state.deleteErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.deleteSuccess = true;
          state.deleteError = false;
        }
      })
      .addCase(deleteProviderGeneralCert.rejected, (state) => {
        state.isDeleteLoading = false;
        state.deleteError = true;
        state.deleteErrorMsg = "Something went wrong! Please try again later.";
      });
  },
});

const saveProviderCertification = createSlice({
  name: "saveProviderCertification",
  initialState: {
    isSaveLoading: false,
    saveSuccess: false,
    saveError: null,
    saveErrorMsg: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveProviderCertifications.pending, (state) => {
        state.isSaveLoading = true;
        state.saveError = null;
        state.saveSuccess = false;
      })
      .addCase(saveProviderCertifications.fulfilled, (state, action) => {
        state.isSaveLoading = false;
        if (!action.payload.success) {
          state.saveError = true;
          state.saveErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.saveSuccess = true;
          state.saveError = false;
        }
      })
      .addCase(saveProviderCertifications.rejected, (state) => {
        state.isSaveLoading = false;
        state.saveError = true;
        state.saveErrorMsg = "Something went wrong! Please try again later.";
      });
  },
});

export const { addUpdateProviderCertification } =
  providerCertificationDetails.actions;

export const providerCertificationSuggestionReducer =
  providerCertificationSuggesions.reducer;
export const providerCertificationDetailsReducer =
  providerCertificationDetails.reducer;
export const deleteProviderCertificationReducer =
  deleteProviderCertification.reducer;
export const saveProviderCertificationReducer =
  saveProviderCertification.reducer;